import { Descendants } from './featuresDescendants';
import { Legends } from './featuresLegends';
import { Cursed } from './featuresCursed';
import { MobileApp } from './featuresApp';
import { Chest } from './featuresChest';

export const Features = (props) => {

  return (
    <div id='features' className='text-center'>
      <div className='container' style={{display: 'flex', justifyContent: 'center'}}>
        <div>
          <div style={{ marginTop: 100 }}>
            <Descendants />
          </div>
          <div style={{ marginTop: 100 }}>
            <Legends />
          </div>
          <div style={{ marginTop: 100 }}>
            <Cursed />
          </div>
          <div style={{ marginTop: 100 }}>
            <MobileApp />
          </div>
          <div style={{ marginTop: 100 }}>
            <Chest />
          </div>
        </div>

      </div>
    </div>

  )
}
